@if (isLoading()) {
  <div class="quota-skeleton"></div>
} @else if (limits(); as l) {
  <div class="quota-indicator" [matTooltip]="tooltip()" matTooltipPosition="above">
    <div class="quota-row">
      <span class="quota-label body-small">Assemblies used</span>
      @if (isMaxed()) {
        <span class="quota-label quota-label--maxed body-small">Maxed</span>
      } @else {
        <span class="quota-label body-small"
          ><span class="quota-current">{{ l.currentToolAssemblies }}</span
          >/{{ l.maximumToolAssemblies }}</span
        >
      }
    </div>
    <mat-progress-bar
      mode="determinate"
      [value]="percentage()"
      [class]="'quota-bar quota-bar--' + level()">
    </mat-progress-bar>
  </div>
}
